import { IPromise } from 'angular';
import { call, CallEffect, ForkEffect, put, PutEffect, takeEvery } from 'redux-saga/effects';
import { Messages } from '../../../../codegen/Localize';
import { IWorkbookBase, IWorkbookInfo } from '../../../../ts/models/IWorkbookInfo';
import { Set } from '../../../../ts/models/Set';
import { IResult } from '../../../../ts/ServerApi/types/IResponse';
import { SetDisplayTabsAction } from '../../../../ts/services/SetDisplayTabsAction';
import { SetTabsWorkbook } from '../../../actions/AppActionTypes';
import {
  requestFailed,
  RequestFailedAction
} from '../../../actions/RequestFailedAction';
import { SetTabsWorkbookAction } from '../../../actions/spaces/SetTabsWorkbookAction';
import { ServiceLocator } from '../../../ServiceLocator';
import { getWorkbookInfos } from '../SpacesSagaHelpers';
import { fetchWorkbookById } from './WorkbookSagas';

export function* setTabsWorkbookSaga(action: SetTabsWorkbookAction) {
    const localizedErrorMessage = Messages.unexpectedError();
    try {
      const workbookInfos = yield getWorkbookInfos(action.workbooks);
      // errors are handled by the dialog - nothing to be done on success
      yield call(openSetTabsWorkbookDialog, workbookInfos);
    } catch(e) {
      yield put(requestFailed(e, localizedErrorMessage));
    }
  }

function openSetTabsWorkbookDialog(workbooks: IWorkbookInfo[]): IPromise<any> {
    const setTabsModule = ServiceLocator.get<SetDisplayTabsAction>('SetDisplayTabsAction');
    const context = ServiceLocator.getAngularActionContext();
    const workbooksSet = Set.fromIdItemArray(workbooks);
    return setTabsModule.confirmSetDisplayTabs(workbooksSet, context);
  }
